import { Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { abbIconsMapper, Icon, materialIcons } from './icons';

@Component({
  selector: 'abb-icon',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './abb-icon.component.html',
  host: {
    class: 'flex',
  },
  styles: ``
})
export class AbbIconComponent {
  name = input.required<Icon>();
  size = input<'small' | 'medium' | 'large'>('medium');
  externalSize = input<string|undefined>(undefined);

  font = computed(() =>
    this.name().startsWith('abb/')
      ? 'ABBIcons'
      : this.name().startsWith('mat/')
      ? 'Material Icons'
      : 'Material Icons Outlined'
  );

  iconContent = computed(() =>
    this.name().startsWith('abb/')
      ? abbIconsMapper[this.size()][
          this.name().slice(4) as keyof (typeof abbIconsMapper)['small']
        ]
      : this.name().startsWith('mat/')
      ? this.name().slice(4)
      : this.name().startsWith('mat-outlined/')
      ? this.name().slice(13)
      : this.name()
  );
}
